import { Box } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

export const MyMDatePicker = (props) => {
  const { value, onChange, formState, name, ...other } = props;
  return (
    <Box >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={value}
          onChange={onChange}
          sx={{ width: "250px" }}
          format="YYYY/MM/DD"
          {...other}
          slotProps={{
            textField: {
              size: "small",
              error: formState?.errors[name] ? true : false,
              helperText: formState?.errors[name]?.message
            }
          }}
        />
      </LocalizationProvider>
    </Box>
  );
};
